module.exports = __webpack_public_path__ + "static/media/cw.f8e767c5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/cw.svg
// module id = 2072
// module chunks = 0